import { cleartaxAxios } from '../../../http-common';
import { DEFAULT_VIEW_MORE_LIMIT, SORT_BY } from '../Utils/constants';

class WebinarsDataService {
  async getAllProductsList() {
    const data = await cleartaxAxios.get(`/f/events/product/`);
    return data;
  }

  async getAllWebinarPaths() {
    const data = await cleartaxAxios.get(`f/events/webinar/`);
    return data;
  }

  async getAllWebinarList(productId = '', searchText = '') {
    const data = await cleartaxAxios.get(
      `/f/events/webinar/?ordering=-airing_at&title=${searchText}&product=${productId}`
    );
    return data;
  }

  async getWebinarBySlug(slug: string) {
    const data = await cleartaxAxios.get(
      `/f/events/webinar/get_by_slug/${slug}/`
    );
    return data;
  }

  async getAllUpcomingWebinars() {
    const data = await cleartaxAxios.get(
      `/f/events/webinar/upcoming_webinars/`
    );
    return data;
  }

  async filterUpcomingWebinars(
    productId = '',
    searchText = '',
    sortBy = SORT_BY.ASCENDING
  ) {
    const data = await cleartaxAxios.get(
      `/f/events/webinar/upcoming_webinars/?ordering=${sortBy}&title=${searchText}&product=${productId}&is_visible=true`
    );
    return data;
  }

  async getSingleWebinar(id: number) {
    const data = await cleartaxAxios.get(`/f/events/webinar/${id}/`);
    return data;
  }

  async filterPastWebinars(
    productId = '',
    searchText = '',
    sortBy = SORT_BY.DESCENDING,
    limit = DEFAULT_VIEW_MORE_LIMIT
  ) {
    const data = await cleartaxAxios.get(
      `/f/events/webinar/finished_webinars/?ordering=${sortBy}&title=${searchText}&product=${productId}&limit=${limit}&is_visible=true`
    );
    return data;
  }
}
export default new WebinarsDataService();
